import { useAuth0 } from '@auth0/auth0-react';
import { useState, useCallback } from 'react';

import { getDownloadUrl } from '../apis/fileApi';

/**
 * Hook to download a receipt file by fetching a presigned S3 URL
 * and opening it in a new browser tab.
 */
export const useReceiptDownload = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadFile = useCallback(
    async (storageKey: string) => {
      setIsDownloading(true);
      try {
        const token = await getAccessTokenSilently();
        const response = await getDownloadUrl(storageKey, token);
        window.open(response.url, '_blank');
      } finally {
        setIsDownloading(false);
      }
    },
    [getAccessTokenSilently]
  );

  return { downloadFile, isDownloading };
};
